import axios from 'axios';

class api {
  static login(user) {
    return axios
      .post('/loginnew', user)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static forgotPassword(email) {
    return axios
      .put('/forgotpassword', {}, { params: { email: email } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static changePassword(password) {
    return axios
      .put(
        '/changepassword',
        { newPassword: password },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getUserData() {
    return axios
      .get('/getuserdata')
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getPaymentHistory() {
    return axios
      .get('/getpaymenthistory')
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getReportedWinners() {
    return axios
      .get('/getreportedwinnersforuser')
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getProvisionLeads() {
    return axios
      .get('/getprovisionleads')
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getProvisionLead(id) {
    return axios
      .get('/getprovisionlead', { params: { provisionLeadId: id } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getOpenProvisionLead(id) {
    return axios
      .get('/getopenprovisionleadnew', { params: { projectId: id } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getAcceptedLead(id) {
    return axios
      .get('/getacceptedlead', { params: { projectId: id } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getAnsweredLead(projectId) {
    return axios
      .get('/getansweredlead', { params: { projectId } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getCurrentQuote(id) {
    return axios
      .get('/getcurrentquote', { params: { provisionLeadId: id } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getCurrentQuoteFilename(id) {
    return axios
      .get('/getcurrentquotefilename', { params: { provisionLeadId: id } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static reportProvisionLeadWon(id, paymentPreference) {
    const data = {
      provisionLeadId: id,
    };

    if (paymentPreference) data[paymentPreference] = true;

    return axios
      .put('/reportprovisionleadwon', JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static reportProvisionLeadLost(id) {
    return axios
      .put('/reportprovisionleadlost', id, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static reportProvisionLeadInvalid(id) {
    return axios
      .put('/reportprovisionleadinvalid', id, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static revertReportedStatus(id) {
    return axios
      .put('/revertreportedstatus', id, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static acceptOpenProvisionLead(id) {
    return axios
      .put('/acceptopenprovisionleadnew', id, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static acceptReportedWin(id, accept, reason, paymentPreference) {
    const data = {
      provisionLeadId: id,
      accept,
    };

    if (accept && paymentPreference) data[paymentPreference] = true;
    if (!accept && reason) data['reason'] = reason;

    return axios
      .post('/acceptreportedwin', JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static requestTimeExtension(id) {
    return axios
      .put('/requesttimeextension', id, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getDetailedProject(id) {
    return axios
      .get('/getdetailedproject', { params: { projectId: id } })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static registerQuote(data) {
    return axios
      .post('/registerquote', data)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static registerQuoteAndFile(data) {
    return axios
      .post('/registerquoteandquotefile', data, {
        headers: {
          'Content-Type': 'multipart/formdata',
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static revertExpiredLead(data) {
    return axios
      .post('/revertexpiredlead', data)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static getProjectUserData(userToken) {
    //userToken = customer token
    return axios
      .get('/getprojectuserdata', {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static reportProjectData(userToken, data) {
    return axios
      .post('/reportprojectdata', data, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }

  static reportProjectWinner(data) {
    return axios
      .post('/reportprojectwinner', data)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  }
}
export default api;
